// extracted by mini-css-extract-plugin
export default {"wrapper":"AreYouSure_wrapper__WSYqY","title":"AreYouSure_title__kn50p","description":"AreYouSure_description__i2in4","shine":"AreYouSure_shine__c26kf"};